import { render } from "./notification-modal.vue?vue&type=template&id=26ca0f5e&scoped=true"
import script from "./notification-modal.vue?vue&type=script&lang=js"
export * from "./notification-modal.vue?vue&type=script&lang=js"

import "./notification-modal.vue?vue&type=style&index=0&id=26ca0f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ca0f5e"]])

export default __exports__